import React from 'react'
import { useParams } from 'react-router-dom'
import LoadingIndicator from 'components/loadingIndicator/LoadingIndicator'
import { useEvidenceData } from 'utils/hooks'
import { EvidenceFilterProvider } from 'context/EvidenceFilterContext'
import EvidenceList from './EvidenceList'
import EvidenceHeader from './EvidenceHeader'

export interface EvidencePageProps {
    isMenuOpen: boolean
    type: string
}

const EvidencePage: React.FC<EvidencePageProps> = ({ isMenuOpen, type }) => {
    const { domainItemId } = useParams<{ domainItemId: string }>()

    const { currentDomainItem, currentHeaderItem, loading } =
        useEvidenceData(domainItemId)

    if (loading) {
        return <LoadingIndicator />
    }

    return (
        <EvidenceFilterProvider>
            <div className="EvidencePage">
                <EvidenceHeader
                    displayableDomainItem={currentHeaderItem}
                    type={type}
                />
                <EvidenceList
                    displayableDomainItem={currentDomainItem}
                    isNegative={
                        currentDomainItem ? currentDomainItem.level < 0 : false
                    }
                    isMenuOpen={isMenuOpen}
                />
            </div>
        </EvidenceFilterProvider>
    )
}

export default EvidencePage
